import { Box, Flex, Text, Portal } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import DeptCategoryManagement from "./departmentTab";
import { usePledgeDepartmentManagementTourGuide } from "@root/hooks/usePledgeDepartmentManagementTourGuide";
import { TourGuide, RestartTourButton } from "@root/components/tour-guide";

export const DepartmentManagement = () => {
  const { t } = useTranslation("common");
  const { pledgeDepartmentManagementTourGuide, isMobile: isMobileTour } =
    usePledgeDepartmentManagementTourGuide();

  return (
    <Flex direction="column" height="100%" bg="white" py={4} px={8}>
      <Text fontWeight={600} fontSize="24px" mb={1}>
        {t("deptManagement.title")}
      </Text>
      <Text color="gray.500" mb={6}>
        {t("deptManagement.subtitle")}
      </Text>
      <Box flex="1" overflowY="auto">
        <DeptCategoryManagement />
      </Box>
      {!isMobileTour && !pledgeDepartmentManagementTourGuide.isActive && (
        <Portal>
          <RestartTourButton
            onClick={pledgeDepartmentManagementTourGuide.startTour}
            position={{ bottom: "24px", right: "24px" }}
          />
        </Portal>
      )}
      {!isMobileTour &&
        pledgeDepartmentManagementTourGuide.isActive &&
        pledgeDepartmentManagementTourGuide.currentStepData && (
          <TourGuide
            isActive={pledgeDepartmentManagementTourGuide.isActive}
            currentStep={pledgeDepartmentManagementTourGuide.currentStepData}
            currentStepIndex={pledgeDepartmentManagementTourGuide.currentStep}
            totalSteps={pledgeDepartmentManagementTourGuide.totalSteps}
            onNext={pledgeDepartmentManagementTourGuide.nextStep}
            onBack={pledgeDepartmentManagementTourGuide.previousStep}
            onClose={pledgeDepartmentManagementTourGuide.stopTour}
            targetSelector={
              pledgeDepartmentManagementTourGuide.currentStepData.targetSelector
            }
            borderRadius="8px"
          />
        )}
    </Flex>
  );
};

export default DepartmentManagement;
